import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "copywriting-assistant-container" }
const _hoisted_2 = { class: "option-column" }
const _hoisted_3 = { class: "custom-el-input search-input" }
const _hoisted_4 = { class: "tag-column" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "scene-column" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "scene-item-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "scene-item-desc" }
const _hoisted_11 = { class: "scene-item-desc-title" }
const _hoisted_12 = { class: "scene-item-desc-desc" }
const _hoisted_13 = { class: "content-column" }

import { ref, onMounted } from 'vue';
import { sceneList } from '@/views/copywritingAssistant/data';
import xhsAssistant from '@/views/xhsAssistant/index.vue';

// 搜索框

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const searchValue = ref('');
// 场景列表
const sceneListData = ref(sceneList);
// 标签列表
const tagList = ref([
  { id: 0, name: '全部' },
  { id: 1, name: '热门应用' },
  { id: 2, name: '小红书' },
  { id: 3, name: '抖音' },
  { id: 4, name: '社交媒体' },
  { id: 5, name: '营销推广' },
]);
// 当前选中的标签id
const currentTagId = ref(1);
// 当前选中的场景
const currentScene = ref(sceneList[0]);
// xhsAssistant组件
const xhsAssistantRef = ref<any>(null);

// 标签点击
const handleTagClick = (id: number) => {
  currentTagId.value = id;
  if (id === 0) {
    sceneListData.value = sceneList;
  } else {
    sceneListData.value = sceneList.filter((item) => item.typeId.includes(id));
  }
};

// 搜索
const handleSearch = () => {
  // 过滤场景列表
  sceneListData.value = sceneList.filter((item) => item.name.includes(searchValue.value));
};

// 场景点击
const handleSceneClick = (item: any) => {
  currentScene.value = item;
};

// 初始化
onMounted(() => {
  handleSceneClick(sceneList[0]);
});

// 搜索框清空
const handleClear = () => {
  searchValue.value = '';
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "content-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "option-column-title" }, [
                _createElementVNode("i", { class: "ri-apps-2-ai-line" }),
                _createElementVNode("span", { class: "title" }, "选择使用场景")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                  class: "search-input-box",
                  modelValue: searchValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                  placeholder: "请输入场景名称",
                  clearable: "",
                  onClear: handleClear,
                  onInput: handleSearch
                }, {
                  prefix: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "ri-seo-line search-icon" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag-item", { 'tag-item-active': currentTagId.value === item.id }]),
                    key: item.id,
                    onClick: ($event: any) => (handleTagClick(item.id))
                  }, _toDisplayString(item.name), 11, _hoisted_5))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (sceneListData.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneListData.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["scene-item", { 'scene-item-active': currentScene.value.id === item.id }]),
                            key: item.id,
                            onClick: ($event: any) => (handleSceneClick(item))
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("img", {
                                src: item.img
                              }, null, 8, _hoisted_9)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(item.desc), 1)
                            ])
                          ], 10, _hoisted_7))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      description: "暂无数据"
                    }))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(xhsAssistant, {
                ref_key: "xhsAssistantRef",
                ref: xhsAssistantRef,
                class: "xhs-assistant",
                scene: currentScene.value
              }, null, 8, ["scene"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})